module.exports = __webpack_public_path__ + "media/bg-text.ed35ffb4.mp4";